<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="board_wrap">
            <div class="board_title">
              <p>{{getNoticeDetail.title}}</p>
            </div>
            <div class="board_body">
              <p class="write_date">
                날짜: {{getNoticeDetail.date | moment("YYYY-MM-DD")}}
              </p>
              <div class="write_space detail">
                <p v-html="getNoticeDetail.content"></p>
              </div>
              <div class="fileBtn" @click="goFile()">
                <button class="fileName"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
          <button type="button" class="callTerms" @click="moveList()">목록</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import EventBus from '@/utils/bus'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '공지사항',
        prevUrl: '/noticeList'
      },
      form: {
        date: {
          value: ''
        }
      },
      setCount: false
    }
  },
  computed: {
    ...mapGetters('notice', [
      'getNoticeDetail'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions('notice', [
      'NOTICE_DETAIL'
    ]),
    moveList () {
      if (sessionStorage.getItem('pathFromLoadUnAuth').indexOf('noticeList') !== 1) {
        this.$router.push('/noticeList')
      } else {
        history.go(-1)
      }
    },
    goUrl () {
    },
    async fetchData () {
      try {
        const code = Number(this.$route.params.code)
        this.NOTICE_DETAIL(code)
          .then(() => {
            console.log('code: ', code)
            this.carryData()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('공지사항 상세보기에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    carryData () {
      console.log('this.getNoticeDetail.file: ', this.getNoticeDetail.file)
      if (this.getNoticeDetail.file !== null) {
        const file = this.getNoticeDetail.file
        const fileName = decodeURIComponent(file.split('/').reverse()[0])
        console.log('fileName: ', fileName)
        const btnText = document.querySelector('.fileName')
        btnText.innerText = fileName
      } else {
        document.querySelector('.fileName').classList.add('btnHide')
      }
    },
    goFile () {
      location.href = 'https://api.thanq.kr' + this.getNoticeDetail.file
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/noticeList')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  filters: {
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  mounted () {
    EventBus.$emit('pageAccess', true)
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    const referrer = document.referrer
    console.log('referrer: ', referrer)
    this.fetchData()
  },
  beforeDestroy () {
    this.setCount = false
    EventBus.$off('pageAccess')
  }
}
</script>

<style lang="scss" scoped>
</style>
